<template>
  <div>
    <b-row>
      <b-col>
        <b-form-group>
          <label class="font-weight-bold" for="name"
            >Buscar proveedor por:</label
          >
          <b-form-radio-group
            size="sm"
            v-model="companyTypeSearch"
            :options="optionsTypeSearch"
            class="mb-3"
            value-field="value"
            text-field="text"
            disabled-field="notEnabled"
          />
          <label class="font-weight-bold" for="name">Proveedor</label>
          <search-select
            v-model="$v.form.company.$model"
            @blur="handleBlur"
            :validation="$v.form.company"
            :url="urlSearchCompany"
          />
        </b-form-group>
        <b-form-group>
          <label class="font-weight-bold" for="name">Nº Orden de compra</label>
          <b-form-input
            autocomplete="off"
            type="text"
            v-model="$v.form.number.$model"
            :state="$v.form.number.$dirty ? !$v.form.number.$error : null"
            id="name"
            placeholder="12345"
          />
        </b-form-group>

        <b-form-group>
          <label>Tipo de moneda</label>
          <b-form-select
            v-model="$v.form.currency.$model"
            :state="$v.form.currency.$dirty ? !$v.form.currency.$error : null"
            :options="optionscurrency"
          ></b-form-select>
        </b-form-group>

        <b-form-group>
          <label class="font-weight-bold" for="name">Fecha del pedido</label>
          <b-form-input
            autocomplete="off"
            type="date"
            v-model="$v.form.order_date.$model"
            :state="
              $v.form.order_date.$dirty ? !$v.form.order_date.$error : null
            "
          />
        </b-form-group>
        <b-form-group>
          <label class="font-weight-bold" for="name">Fecha de entrega</label>
          <b-form-input
            autocomplete="off"
            type="date"
            v-model="$v.form.delivery_date.$model"
            :state="
              $v.form.delivery_date.$dirty
                ? !$v.form.delivery_date.$error
                : null
            "
          />
        </b-form-group>
      </b-col>
      <b-col>
        <b-card
          class="h-60"
          bg-variant="secondary"
          :title="form.company.company_name"
        >
          <b-card-text>
            <p><b>Rut: </b> {{ form.company.text }}</p>
            <p>
              <b>Dirección: </b> {{ form.company.address1 }} <br />
              {{ form.company.address2 }}
            </p>
            <p><b>Teléfono: </b>{{ form.company.phone }}</p>
          </b-card-text>
        </b-card>

        <b-form-group>
          <label for="textarea-auto-height">Notas:</label>
          <b-form-textarea
            v-model="form.observation"
            placeholder="Escriba acá notas relacionadas con la orden de compra."
            rows="4"
            max-rows="4"
          >
          </b-form-textarea>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-button
          class="mb-3"
          variant="primary"
          :disabled="
            !form.company.company_name ||
            !form.number ||
            !form.order_date ||
            !form.currency ||
            !form.delivery_date
          "
          @click="CreateDetailedSupplies"
          >Agregar Material
        </b-button>
        <b-button class="ml-2 mb-3" variant="danger" @click.prevent="removeAll"
          >Eliminar todo
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <create-content-table
          :form="form"
          :supplyfamilyOptions="supplyfamilyOptions"
          ref="table"
        />
      </b-col>
    </b-row>

    <create-detailed-supplies-modal
      ref="CreateDetailedSupplies"
      :form="form"
      :supplyfamilyOptions="supplyfamilyOptions"
    />
  </div>
</template>

<script>
import CreateDetailedSuppliesModal from "./CreateDetailedSuppliesModal.vue";
import createContentTable from "./CreateContentTable.vue";

import { integer, required, decimal } from "vuelidate/lib/validators";
import { mapState, mapGetters } from "vuex";
import searchSelect from "../reusable/searchSelect";

export default {
  name: "CreateContent",
  components: {
    searchSelect,
    CreateDetailedSuppliesModal,
    createContentTable
  },
  data() {
    return {
      submitActive: false,
      companyTypeSearch: "1",
      optionsTypeSearch: [
        { text: "Rut", value: "1" },
        { text: "Nombre", value: "2" }
      ],
      supplyfamilyOptions: null,
      optionscurrency: [
        { value: "Pesos", text: "Pesos" },
        { value: "Dolar", text: "Dolar" }
      ]
    };
  },
  props: {
    form: {
      type: Object,
      default: {}
    }
  },
  computed: {
    classObject: function () {
      return {
        "custom-select": true,
        "style-chooser": true,
        "is-valid":
          this.form.document_type != null &&
          this.$v.form.document_type.$dirty == true
            ? true
            : false,
        "is-invalid":
          this.form.document_type == null &&
          (this.$v.form.document_type.$dirty == true ||
            this.submitActive == true)
            ? true
            : false
      };
    },
    classObjectContainer: function () {
      return {
        "custom-select": true,
        "style-chooser": true,
        "is-valid":
          this.form.container.text != null &&
          this.$v.form.container.$dirty == true
            ? true
            : false,
        "is-invalid":
          this.form.container.text == null &&
          (this.$v.form.container.$dirty == true || this.submitActive == true)
            ? true
            : false
      };
    },
    urlSearchCompany: function () {
      return (
        "/api/supplies/company/select_company/?type=" + this.companyTypeSearch
      );
    }
  },
  watch: {},
  methods: {
    loadSupplyfamilyOptions() {
      this.supplyfamilyOptions = [{ id: "", name: "Cargando..." }];
      this.$axios
        .get("/api/supplies/supply-family/select_input/")
        .then((res) => {
          this.supplyfamilyOptions = res.data;
        })
        .catch((error) => console.log(error));
    },
    CreateDetailedSupplies() {
      this.$refs.CreateDetailedSupplies.modalShown = true;
    },
    debug(event) {
      console.log(event.target.name);
    },
    handleBlur(evt) {
      //alert(JSON.stringify(evt));
    },
    resetForm() {
      this.form.product = null;
      this.form.pallet_quantity = null;
    },
    removeAll() {
      this.form.detailedSupplies = [];
    },
    inputSoloNumero(event) {
      event.target.value = event.target.value.replace(/[^0-9]/, "");
    },
    inputSoloNumeroDecimal(event) {
      event.target.value = event.target.value.replace(/[^0-9.]/, "");
    }
  },
  validations: {
    form: {
      company: { required },
      order_date: { required },
      delivery_date: { required },
      number: { required },
      currency: { required }
    }
  },
  mounted() {
    this.loadSupplyfamilyOptions();
  }
};
</script>

<style>
.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__dropdown-menu {
  min-height: calc(1.5em + 0.75rem + 2px);
  font-size: 0.6875rem;
  font-weight: 400;
  color: #5c6873;
  border: none;
  margin-top: -7px;
  margin-left: -10px;
}
.style-chooser .vs__clear,
.style-chooser .vs__open-indicator {
  fill: #394066;
}
</style>
